import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 9.063V.865l-1.64 1.367-2.07 1.725 1.178 1.621.532-.443V6.31l2 2.753Zm-5.623-.91-.459.383A2 2 0 0 1 4.638 9H2v6h2.638a2 2 0 0 1 1.28.464L10 18.865V13.14L6.377 8.154ZM5.2 6.534 2.633 3h2.472l13.078 18H15.71L12 15.893v7.242l-1.64-1.367L4.638 17H2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2.638l.561-.468Zm14.155 12.652A9.1 9.1 0 0 0 14 2.8v2a7.1 7.1 0 0 1 4.178 12.766l1.176 1.618Zm-2.916-4.014A4 4 0 0 0 14 8v2a2 2 0 0 1 1.262 3.552l1.176 1.62Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconMediaSoundOff24 = createIcon(IconComponent);